export default __webpack_public_path__ + "static/media/loha_fms2.5cb0a41a.jpg";